export default __webpack_public_path__ + "static/media/bubblesFinal.a1866e96.svg";